import React, { useRef } from "react";
import { useGoogleLogout } from "react-google-login";
import { useSelector } from "react-redux";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { socket } from "../../helpers/socketHelper";
import { clearToken } from "../../helpers/utility";
import { getImage, getUserProfile } from "../../store/user/user.selector";

const AccountPreferences = () => {
    const history = useNavigate();
    const location = useLocation();
    const clientId = process.env.REACT_APP_GOOGLE_ID;
    const scrollRef = useRef(null);
    const scrollH = (e) => {
        e = window.event || e;
        let delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
        scrollRef.current.scrollLeft -= delta * 40;
    };

    const { userProfile, livestream } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            livestream: state.SocialReducer.createLiveStreamResponse,
        };
    });

    const onLogoutSuccess = (res) => {
        clearToken();
        console.log("Logged out Success");
        document.location.href = "/";
    };

    const handleLogout = () => {
        if (livestream._id && livestream.streamingStatus === "Streaming") {
            Swal.fire({
                title: "Confirm log out?",
                text:
                    livestream.owner._id === userProfile._id
                        ? "Logging out will end the livestream. "
                        : "Logging out will leave the livestream. ",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "green",
                cancelButtonText: "Cancel",
                confirmButtonText: "Proceed",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    if (livestream.owner._id === userProfile._id) {
                        socket.emit("endLive", {
                            room: livestream._id,
                            type: "host",
                            infoUser: userProfile,
                        });
                    } else {
                        socket.emit("leftLive", {
                            room: livestream._id,
                            type: "viewers",
                            infoUser: userProfile,
                        });
                    }

                    if (navigator.mediaDevices.getUserMedia) {
                        navigator.mediaDevices
                            .getUserMedia({ video: true })
                            .then(function (stream) {
                                var video = document.querySelector("video");
                                video.srcObject = stream;
                            })
                            .catch(function () {
                                console.log("Something went wrong!");
                            });
                    }
                }
                onLogoutSuccess();
            });
        } else {
            onLogoutSuccess();
        }
    };

    return (
        <div className="flex h-full">
            <div className=" w-full md:flex-1 p-2 sm:p-4 md:px-8 md:py-7 flex flex-col">
                <div className="mb-1.5">
                    <h2 className="text-xl font-bold text-ebony-color">
                        Account & preferences
                    </h2>
                </div>

                <div className="bg-white p-2.5 sm:p-4 pb-0 sm:pb-0 rounded-tl-lg rounded-tr-lg">
                    <div
                        onWheel={(e) => scrollH(e)}
                        ref={scrollRef}
                        className="w-full overflow-scroll no-scrollbar"
                    >
                        <ul className="w-full flex items-center pb-[5px] border-b border-black-10">
                            <li>
                                <NavLink
                                    to="/page/account/profile"
                                    className={`text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-3.5 view-profile-nav whitespace-nowrap ${
                                        location.pathname == "/page/account"
                                            ? "active"
                                            : ""
                                    }`}
                                >
                                    Profile
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/page/account/password"
                                    className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-3.5 view-profile-nav whitespace-nowrap"
                                >
                                    Password
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/page/account/address"
                                    className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-3.5 view-profile-nav whitespace-nowrap"
                                >
                                    Address
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/page/account/payment"
                                    className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-3.5 view-profile-nav whitespace-nowrap"
                                >
                                    Payment
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/page/account/withdrawal"
                                    className={`text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${
                                        location.pathname ==
                                        "/page/account/withdraw-balance"
                                            ? "active"
                                            : ""
                                    }`}
                                >
                                    Withdrawal
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/page/account/privacySettings"
                                    className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-3.5 view-profile-nav whitespace-nowrap"
                                >
                                    Privacy Settings
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/page/account/plan"
                                    className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-3.5 view-profile-nav whitespace-nowrap"
                                >
                                    Plan
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="flex-grow overflow-y-auto overflow-x-hidden bg-white p-2.5 sm:p-4 rounded-bl-lg rounded-br-lg">
                    <Outlet />
                </div>
            </div>

            <div
                className={`w-[300px] bg-white px-4 overflow-y-auto overflow-hidden hidden lg:block`}
            >
                <div className="h-full flex flex-col justify-between">
                    <div className="">
                        <div className="mb-[22px]">
                            <div className=" flex flex-col items-center mt-6 mb-5">
                                <img
                                    src={getImage(
                                        userProfile.avatar.attachments
                                    )}
                                    className="w-[108px] h-[108px] rounded-full mb-1.5"
                                    alt=""
                                />
                                <div className="text-center relative">
                                    {userProfile.role === "Pro" && (
                                        <button className="absolute p-2 py-1 text-sm font-bold text-white bg-orange-color block rounded-lg right-[-50px] top-[-5px]">
                                            Pro
                                        </button>
                                    )}
                                    <h5 className="text-sm text-ebony-color font-medium mb-px">
                                        {userProfile.fullName}
                                    </h5>
                                    <p className="text-sm text-black-70">
                                        @{userProfile.userName}
                                    </p>
                                </div>
                            </div>
                            <div className="flex justify-between px-4 mb-[22px]">
                                <div
                                    className="text-center cursor-pointer"
                                    onClick={() =>
                                        history("/page/profile/list#follower")
                                    }
                                >
                                    <span className="text-lg mb-0.5 font-bold text-ebony-color">
                                        {userProfile.countFollower}
                                    </span>
                                    <p className="text-sm text-black-50">
                                        Followers
                                    </p>
                                </div>
                                <div
                                    className="text-center cursor-pointer mx-3"
                                    onClick={() =>
                                        history("/page/profile/list#following")
                                    }
                                >
                                    <span className="text-lg mb-0.5 font-bold text-ebony-color">
                                        {userProfile.countFollowing}
                                    </span>
                                    <p className="text-sm text-black-50">
                                        Following
                                    </p>
                                </div>
                                <div
                                    className="text-center cursor-pointer"
                                    onClick={() =>
                                        history("/page/profile/list#subscriber")
                                    }
                                >
                                    <span className="text-lg mb-0.5 font-bold text-ebony-color">
                                        {userProfile.countSubscriber}
                                    </span>
                                    <p className="text-sm text-black-50">
                                        Subscribers
                                    </p>
                                </div>
                            </div>
                            <div className="">
                                <button
                                    onClick={() =>
                                        history("/page/start-new-video")
                                    }
                                    className="text-sm font-bold text-white py-2.5 bg-orange-color w-full block rounded-lg"
                                >
                                    Start new video
                                </button>
                            </div>
                        </div>

                        {/* Profile nav  */}
                        <ul className="flex flex-col gap-y-1">
                            <li>
                                <NavLink
                                    to="/page/profile"
                                    className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color profile-nav"
                                >
                                    <div className="mr-4 p-2 bg-black-5 rounded-md">
                                        <svg
                                            width="16"
                                            height="16"
                                            className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M1.75 15.5C1.75 15.5 0.5 15.5 0.5 14.25C0.5 13 1.75 9.25 8 9.25C14.25 9.25 15.5 13 15.5 14.25C15.5 15.5 14.25 15.5 14.25 15.5H1.75ZM8 8C8.99456 8 9.94839 7.60491 10.6517 6.90165C11.3549 6.19839 11.75 5.24456 11.75 4.25C11.75 3.25544 11.3549 2.30161 10.6517 1.59835C9.94839 0.895088 8.99456 0.5 8 0.5C7.00544 0.5 6.05161 0.895088 5.34835 1.59835C4.64509 2.30161 4.25 3.25544 4.25 4.25C4.25 5.24456 4.64509 6.19839 5.34835 6.90165C6.05161 7.60491 7.00544 8 8 8Z" />
                                        </svg>
                                    </div>
                                    <span className="capitalize text-sm font-medium">
                                        View profile
                                    </span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/page/account"
                                    className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color profile-nav"
                                >
                                    <div className="mr-4 p-2 bg-black-5 rounded-md">
                                        <svg
                                            width="17"
                                            height="19"
                                            className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                            viewBox="0 0 17 19"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M2.33366 8.3335V14.1668H4.83366V8.3335H2.33366ZM7.33366 8.3335V14.1668H9.83366V8.3335H7.33366ZM0.666992 18.3335H16.5003V15.8335H0.666992V18.3335ZM12.3337 8.3335V14.1668H14.8337V8.3335H12.3337ZM8.58366 0.833496L0.666992 5.00016V6.66683H16.5003V5.00016L8.58366 0.833496Z" />
                                        </svg>
                                    </div>
                                    <span className="capitalize text-sm font-medium">
                                        Account & preferences
                                    </span>
                                </NavLink>
                            </li>
                            {/* <li>
                                <NavLink
                                    to="/vf"
                                    className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color profile-nav"
                                >
                                    <div className="mr-4 p-2 bg-black-5 rounded-md">
                                        <svg
                                            width="16"
                                            height="16"
                                            className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M8 15.4998C5.90278 15.4998 4.12833 14.774 2.67667 13.3223C1.22556 11.8712 0.5 10.0971 0.5 7.99984C0.5 6.08317 1.125 4.41984 2.375 3.00984C3.625 1.60039 5.22222 0.777615 7.16667 0.541504C7.51389 0.499837 7.78472 0.624837 7.97917 0.916504C8.17361 1.20817 8.16667 1.51373 7.95833 1.83317C7.72222 2.19428 7.545 2.57623 7.42667 2.979C7.30889 3.38178 7.25 3.80539 7.25 4.24984C7.25 5.49984 7.6875 6.56234 8.5625 7.43734C9.4375 8.31234 10.5 8.74984 11.75 8.74984C12.1806 8.74984 12.6078 8.68734 13.0317 8.56234C13.455 8.43734 13.8333 8.26373 14.1667 8.0415C14.4583 7.84706 14.7569 7.8365 15.0625 8.00984C15.3681 8.18373 15.5 8.45817 15.4583 8.83317C15.2639 10.7498 14.4481 12.3401 13.0108 13.604C11.5731 14.8679 9.90278 15.4998 8 15.4998Z" />
                                        </svg>
                                    </div>
                                    <span className="capitalize text-sm font-medium">
                                        Dark mode
                                    </span>
                                </NavLink>
                            </li> */}
                            <li>
                                <NavLink
                                    onClick={() => handleLogout()}
                                    className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color"
                                >
                                    <div className="mr-4 p-2 bg-black-5 rounded-md">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M15.3203 8.44531L12.0391 11.7266C11.9191 11.8412 11.7597 11.9055 11.5938 11.9062C11.5133 11.9065 11.4336 11.8905 11.3594 11.8594C11.2442 11.8128 11.1455 11.7329 11.0759 11.6299C11.0063 11.5269 10.969 11.4055 10.9688 11.2812V8.625H6.125C5.95924 8.625 5.80027 8.55915 5.68306 8.44194C5.56585 8.32473 5.5 8.16576 5.5 8C5.5 7.83424 5.56585 7.67527 5.68306 7.55806C5.80027 7.44085 5.95924 7.375 6.125 7.375H10.9688V4.71875C10.969 4.59447 11.0063 4.47308 11.0759 4.37011C11.1455 4.26713 11.2442 4.18723 11.3594 4.14062C11.4735 4.0953 11.5982 4.08372 11.7187 4.10727C11.8392 4.13082 11.9504 4.18849 12.0391 4.27344L15.3203 7.55469C15.4377 7.67318 15.5035 7.83322 15.5035 8C15.5035 8.16678 15.4377 8.32682 15.3203 8.44531ZM6.125 14.25H1.75V1.75H6.125C6.29076 1.75 6.44973 1.68415 6.56694 1.56694C6.68415 1.44973 6.75 1.29076 6.75 1.125C6.75 0.95924 6.68415 0.800269 6.56694 0.683058C6.44973 0.565848 6.29076 0.5 6.125 0.5H1.75C1.41848 0.5 1.10054 0.631696 0.866116 0.866116C0.631696 1.10054 0.5 1.41848 0.5 1.75V14.25C0.5 14.5815 0.631696 14.8995 0.866116 15.1339C1.10054 15.3683 1.41848 15.5 1.75 15.5H6.125C6.29076 15.5 6.44973 15.4342 6.56694 15.3169C6.68415 15.1997 6.75 15.0408 6.75 14.875C6.75 14.7092 6.68415 14.5503 6.56694 14.4331C6.44973 14.3158 6.29076 14.25 6.125 14.25Z" />
                                        </svg>
                                    </div>
                                    <span className="capitalize text-sm font-medium">
                                        Sign out
                                    </span>
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    <div className="pt-1 pb-4 border-t border-black-10 text-center mt-28">
                        <p className="text-sm font-medium text-black-30">
                            &copy; 2022 Ulalive Inc
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountPreferences;
